<!-- 
Panel showing details of a role.
-->
<template>
  <div>
    <our-loading-indicator v-if="state.loading" />
    <div v-else>
      <our-data-container>
        <our-data-field label="Name">{{ role.name }}</our-data-field>
        <our-data-field label="PRISMS name">{{ role.prismsName }}</our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container>
        <our-data-field 
          v-for="category in categories" 
          :key="category" 
          :label="lookups.permissionCategoryDescriptions[category] + ' permissions'"
          empty="None"
        >
          <our-lookups-list :values="getPermissions(category)" :lookups="lookups.permissionClaimTypes"/>
        </our-data-field>
      </our-data-container>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/roles/action-types";

export default {
  mixins: [lookupMixins],
  props: {
    roleId: {
      required: true,
      type: Number
    }
  },
  computed: {
    state() {
      return this.$store.state.roles.view;
    },
    role() {
      return this.state.data;
    },
    categories() {
      return _(this.lookups.permissionCategories).pluck("value");
    }
  },
  watch: {
    roleId() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      await this.$store.dispatch(action.VIEW_REFRESH, this.roleId);
    },
    getPermissions(category) {
      const all = this.getAllPermissionsInCategory(category);
      return _(this.role.permissions).intersection(all);
    },
    getAllPermissionsInCategory(category) {
      const permissions = _(this.lookups.permissionClaimTypes).filter(
        p => p.attributeData.permissionCategory.category == category
      );
      return _(permissions).pluck("value");
    }
  }
};
</script>
